import { createAsyncThunk } from '@reduxjs/toolkit';

import * as Sentry from '@sentry/browser';

import * as APIClient from 'Services/APIClient';
import { isNotAuthenticated } from 'Services/HTTPError';

export type Country = {
  name: string;
  code: string;
  states: string[][];
};

export const fetchCountries = createAsyncThunk('countries/fetchCountries', async () => {
  try {
    const response = await APIClient.get('/v1/countries/');
    const countries = (await response.json()) as Country[];
    return { countries };
  } catch (error) {
    Sentry.withScope((scope) => {
      if (isNotAuthenticated(error)) {
        scope.setLevel('error');
        Sentry.captureMessage(`[Countries] fetchCountries: ${error.toString()}`);
      }
    });
    throw error;
  }
});
